import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const FileField = ({
    name,
    type,
    label,
    error,
    info,
    onChange,
    required,
}) => {
  return (
    <div className="form-group">
        <label className='form-label'>{label}</label>
        <input type={type} className={classnames('form-control', {'is-invalid' : error})} name={name} onChange={onChange} required={required} aria-label="Default" aria-describedby="inputGroup-sizing-default"/>
        {info && <small className='form-text text-muted'>{info}</small>}
        {error && <div className="invalid-feedback mb-2" style={{textAlign: 'left'}}>{error}</div>}
    </div>
  )
}
FileField.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]).isRequired,
    label: PropTypes.string,
    error: PropTypes.string,
    info: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.string,
}


FileField.defaultProps = {
    type: 'file'
}

export default FileField
